import { ActionRegistry } from './ActionRegistry'
import { ActionConfig, ActionContext, ActionTypeMap, IAction } from './Action'

export type ActionParam = {
    id: keyof ActionTypeMap
    config?: ActionConfig
}

export class ActionManager {
    private actionRegistry: ActionRegistry
    private actionsMap: Map<string, IAction> = new Map()

    constructor(private actionContext: ActionContext) {
        this.actionRegistry = ActionRegistry.getInstance()
    }

    addActions(actions: ActionParam[]) {
        actions.forEach(action => {
            const actionClass = this.actionRegistry.getAction(action.id)
            if (actionClass) {
                const actionInstance = new actionClass(this.actionContext, action.config)
                this.actionsMap.set(action.id, actionInstance)
            } else {
                console.error(`Action with id ${action.id} not found`)
            }
        })
    }

    removeActions(actionIds: string[]) {
        actionIds.forEach(actionId => {
            const actionInstance = this.actionsMap.get(actionId)
            if (actionInstance) {
                actionInstance.removeFromWorkbench()
                this.actionsMap.delete(actionId)
            } else {
                console.error(`Action with id ${actionId} not found`)
            }
        })
    }
}
